import * as React from 'react';
import propz from 'propz';
import moment from 'moment';
import { EventInvitationMessage } from 'Src/models/message';
import { SchoolEvent } from 'Src/models/event';
import '../../components/ParentDesign.scss';

interface Props {
  item: EventInvitationMessage;
  event: SchoolEvent;
  activeSchoolId: string;
}

export const AvailabilityReportsDetails = (props: Props) => {
  const { item, event, activeSchoolId } = props;
  const details = propz.get(item, ['details'], '');
  const senderFullName = propz.get(item, ['sender', 'fullName'], '');
  const isTakePart = !!propz.get(item, ['isTakePart'], false);
  const isSentByStudent = String(propz.get(item, ['sender', 'userId'], '')) === String(propz.get(item, ['playerDetails', 'userId'], ''));
  const createdAt = propz.get(item, ['createdAt']);
  const createdAtFormatted = moment(createdAt).format('DD-MM-YYYY HH:mm');
  const isDetailsExist = details !== '';
  const detailsText = isDetailsExist ? details : 'Details are not specified';
  const generatedNames = propz.get(event, ['generatedNames']);
  const isGeneratedNamesExist = generatedNames && typeof generatedNames === 'object';
  let eventName;

  if (isGeneratedNamesExist) {
    const schoolIdsFromGeneratedNames = Object.keys(generatedNames);
    const isActiveSchoolIdExistInGeneratedNames = schoolIdsFromGeneratedNames.includes(activeSchoolId);

    eventName = isActiveSchoolIdExistInGeneratedNames ? generatedNames[activeSchoolId] : generatedNames.official;
  } else {
    eventName = 'Event name not assigned';
  }

  const startTime = propz.get(event, ['startTime'], '');
  const endTime = propz.get(event, ['endTime'], '');
  const startTimeFormatted = moment(startTime).format('DD-MM-YYYY HH:mm');
  const endTimeFormatted = moment(endTime).format('DD-MM-YYYY HH:mm');

  const rows = [
    ['Event', eventName || 'Event name not assigned'],
    ['Starts', startTimeFormatted],
    ['Finishes', endTimeFormatted],
    ['Sent by', `${senderFullName || '—'} (${isSentByStudent ? 'student' : 'parent'})`],
    ['Sent at', createdAtFormatted],
    ['Details', detailsText]
  ];

  return (
    <div className="parentDetailPanel">
      <div className="parentDetailPanel__intro">
        <span aria-hidden="true">✓</span>
        <div><h3>Availability response</h3><p>The response sent to the school for this event.</p>
          <span className={`parentDetailPanel__status ${isTakePart ? 'is-positive' : 'is-negative'}`}>{isTakePart ? 'Available' : 'Not available'}</span>
        </div>
      </div>
      <dl className="parentDetailPanel__list">
        {rows.map(([label, value]) => (
          <div key={label}><dt>{label}</dt><dd>{value}</dd></div>
        ))}
      </dl>
    </div>
  );
};

AvailabilityReportsDetails.displayName = 'AvailabilityReportsDetails';



